<template>
  <div>
    <div class="modal-body">
      <!-- <div class="row">
        <div
          v-if="$route.name === 'OrderConfirm'"
          class="col-6 fs-18"
        >{{ $t("lbl_sample_document") }}</div>
        <div class="col-6 fs-18">
          {{
          $route.name === "OrderConfirm"
          ? $t("lbl_upload")
          : $t("lbl_uploaded_attachment")
          }}
        </div>
        <div class="col-4 fs-20">{{ $t('lbl_status') }}</div>
      </div>-->
      <div
        class="mb-2 flex items-center"
        :class="$route.name !== 'ProductOrderInvoice'?'row':''"
        v-for="(item, index) in attachmentsData"
        :key="item.id"
      >
        <span
          class="font-weight-bold fs-17 italic"
          :class="$route.name !== 'ProductOrderInvoice'?'mb-1':'mb-0'"
        >{{ item.title }}:</span>
        <div
          v-if="$route.name === 'OrderConfirm'"
          @click="handleOpenFile(item.url_exam)"
          class="col-6 cursor-pointer"
        >
          <span class="cs-link">
            <u>{{ getFileName(item.url_exam) }}</u>
          </span>
        </div>
        <div class="col-6">
          <div v-if="!item.url" class="upload-btn" @click="handleUploadDocs(index, item)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M7.25842 6.42508L9.16675 4.50841V12.5001C9.16675 12.7211 9.25455 12.9331 9.41083 13.0893C9.56711 13.2456 9.77907 13.3334 10.0001 13.3334C10.2211 13.3334 10.4331 13.2456 10.5893 13.0893C10.7456 12.9331 10.8334 12.7211 10.8334 12.5001V4.50841L12.7417 6.42508C12.8192 6.50318 12.9114 6.56518 13.0129 6.60749C13.1145 6.64979 13.2234 6.67158 13.3334 6.67158C13.4434 6.67158 13.5523 6.64979 13.6539 6.60749C13.7554 6.56518 13.8476 6.50318 13.9251 6.42508C14.0032 6.34761 14.0652 6.25544 14.1075 6.15389C14.1498 6.05234 14.1716 5.94342 14.1716 5.83341C14.1716 5.7234 14.1498 5.61448 14.1075 5.51293C14.0652 5.41138 14.0032 5.31921 13.9251 5.24174L10.5917 1.90841C10.5125 1.83254 10.419 1.77307 10.3167 1.73341C10.1139 1.65006 9.8863 1.65006 9.68342 1.73341C9.58112 1.77307 9.48767 1.83254 9.40841 1.90841L6.07508 5.24174C5.99738 5.31944 5.93575 5.41168 5.8937 5.5132C5.85165 5.61472 5.83001 5.72353 5.83001 5.83341C5.83001 5.94329 5.85165 6.0521 5.8937 6.15362C5.93575 6.25514 5.99738 6.34738 6.07508 6.42508C6.15278 6.50278 6.24502 6.56441 6.34654 6.60646C6.44806 6.64851 6.55687 6.67015 6.66675 6.67015C6.77663 6.67015 6.88544 6.64851 6.98696 6.60646C7.08847 6.56441 7.18072 6.50278 7.25842 6.42508ZM17.5001 10.0001C17.2791 10.0001 17.0671 10.0879 16.9108 10.2442C16.7545 10.4004 16.6667 10.6124 16.6667 10.8334V15.8334C16.6667 16.0544 16.579 16.2664 16.4227 16.4227C16.2664 16.5789 16.0544 16.6667 15.8334 16.6667H4.16675C3.94573 16.6667 3.73377 16.5789 3.57749 16.4227C3.42121 16.2664 3.33341 16.0544 3.33341 15.8334V10.8334C3.33341 10.6124 3.24562 10.4004 3.08934 10.2442C2.93306 10.0879 2.7211 10.0001 2.50008 10.0001C2.27907 10.0001 2.06711 10.0879 1.91083 10.2442C1.75455 10.4004 1.66675 10.6124 1.66675 10.8334V15.8334C1.66675 16.4965 1.93014 17.1323 2.39898 17.6012C2.86782 18.07 3.50371 18.3334 4.16675 18.3334H15.8334C16.4965 18.3334 17.1323 18.07 17.6012 17.6012C18.07 17.1323 18.3334 16.4965 18.3334 15.8334V10.8334C18.3334 10.6124 18.2456 10.4004 18.0893 10.2442C17.9331 10.0879 17.7211 10.0001 17.5001 10.0001Z"
                fill="#20419B"
              />
            </svg>
            <span class="fs-14 txt-pri">{{ $t("lbl_select_file") }}</span>
          </div>
          <div v-else class="flex items-center gap-4">
            <div @click="handleOpenFile(item.url)" class="cursor-pointer" v-if="item.url">
              <span class="cs-link">
                <u>{{ getFileName(item.url) }}</u>
              </span>
            </div>
            <button
              class="btn text-white bg-pri h-8 flex items-center justify-center py-1 px-3 gap-2"
              v-if="item.status !== ORDER_FORM_CONFIG_STATUS.ACCEPT&& $route.name !== 'ProductOrderInvoice'"
              @click="handleUploadDocs(index, item)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="cursor-pointer"
              >
                <path
                  d="M13 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V5C5 4.73478 5.10536 4.48043 5.29289 4.29289C5.48043 4.10536 5.73478 4 6 4H11V7C11 7.79565 11.3161 8.55871 11.8787 9.12132C12.4413 9.68393 13.2044 10 14 10H17V12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12V9C19 9 19 9 19 8.94C18.9896 8.84813 18.9695 8.75763 18.94 8.67V8.58C18.8919 8.47718 18.8278 8.38267 18.75 8.3L12.75 2.3C12.6673 2.22222 12.5728 2.15808 12.47 2.11C12.4402 2.10576 12.4099 2.10576 12.38 2.11C12.2784 2.05174 12.1662 2.01434 12.05 2H6C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H13C13.2652 22 13.5196 21.8946 13.7071 21.7071C13.8946 21.5196 14 21.2652 14 21C14 20.7348 13.8946 20.4804 13.7071 20.2929C13.5196 20.1054 13.2652 20 13 20ZM13 5.41L15.59 8H14C13.7348 8 13.4804 7.89464 13.2929 7.70711C13.1054 7.51957 13 7.26522 13 7V5.41ZM8 8C7.73478 8 7.48043 8.10536 7.29289 8.29289C7.10536 8.48043 7 8.73478 7 9C7 9.26522 7.10536 9.51957 7.29289 9.70711C7.48043 9.89464 7.73478 10 8 10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9C10 8.73478 9.89464 8.48043 9.70711 8.29289C9.51957 8.10536 9.26522 8 9 8H8ZM14 12H8C7.73478 12 7.48043 12.1054 7.29289 12.2929C7.10536 12.4804 7 12.7348 7 13C7 13.2652 7.10536 13.5196 7.29289 13.7071C7.48043 13.8946 7.73478 14 8 14H14C14.2652 14 14.5196 13.8946 14.7071 13.7071C14.8946 13.5196 15 13.2652 15 13C15 12.7348 14.8946 12.4804 14.7071 12.2929C14.5196 12.1054 14.2652 12 14 12ZM20.71 17.29L18.71 15.29C18.6149 15.199 18.5028 15.1276 18.38 15.08C18.1365 14.98 17.8635 14.98 17.62 15.08C17.4972 15.1276 17.3851 15.199 17.29 15.29L15.29 17.29C15.1017 17.4783 14.9959 17.7337 14.9959 18C14.9959 18.2663 15.1017 18.5217 15.29 18.71C15.4783 18.8983 15.7337 19.0041 16 19.0041C16.2663 19.0041 16.5217 18.8983 16.71 18.71L17 18.41V21C17 21.2652 17.1054 21.5196 17.2929 21.7071C17.4804 21.8946 17.7348 22 18 22C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V18.41L19.29 18.71C19.383 18.8037 19.4936 18.8781 19.6154 18.9289C19.7373 18.9797 19.868 19.0058 20 19.0058C20.132 19.0058 20.2627 18.9797 20.3846 18.9289C20.5064 18.8781 20.617 18.8037 20.71 18.71C20.8037 18.617 20.8781 18.5064 20.9289 18.3846C20.9797 18.2627 21.0058 18.132 21.0058 18C21.0058 17.868 20.9797 17.7373 20.9289 17.6154C20.8781 17.4936 20.8037 17.383 20.71 17.29ZM12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16H8C7.73478 16 7.48043 16.1054 7.29289 16.2929C7.10536 16.4804 7 16.7348 7 17C7 17.2652 7.10536 17.5196 7.29289 17.7071C7.48043 17.8946 7.73478 18 8 18H12Z"
                  fill="white"
                />
              </svg>
              <span>Thay đổi</span>
            </button>
          </div>

          <input
            :ref="`uploadFile-${index}-${item.id}`"
            class="d-none"
            type="file"
            @change="(e) => handleSelectFileUpdate(e, item,index)"
          />
        </div>
        <!-- <div class="col-4">
              <div class="flex gap-2">
                <div class :set="status = getOrderStatus(item.status)">
                  <div class="flex items-center gap-1">
                    <span
                      class="ml-2 flex text-sm border rounded-xl px-2 py-1"
                      :class="status.classes"
                    >{{ getStatusLabel(item.status) }}</span>
                    <span v-if="item.status===ORDER_FORM_CONFIG_STATUS.REJECT">: {{ item.reason }}</span>
                  </div>
                </div>
              </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import { ORDER_FORM_CONFIG_STATUS } from '../../utils/constant'

export default {
  name: 'ModalAttachmentRequired',
  props: {
    attachments: Array,
    productId: Number
  },
  data () {
    return {
      appUtils,
      attachmentsData: [],
      isLoading: false,
      ORDER_FORM_CONFIG_STATUS,
      isDisabled: false
    }
  },
  mounted () {
    if (this.attachments.length > 0) {
      this.attachmentsData = [...this.attachments]
      this.isDisabled =
        !this.attachments?.some(
          item => item.status !== ORDER_FORM_CONFIG_STATUS.ACCEPT
        ) || this.$route.name === 'ProductOrderInvoice'
    }
  },
  watch: {
    // attachments (data) {
    //   console.log(data)
    //   if (data.length > 0) {
    //     this.attachmentsData = data
    //   }
    // }
  },
  computed: {
    isDisabledUpload () {
      return this.attachments?.every(item => !item.url)
    }
  },
  methods: {
    async handleUpload (item) {
      try {
        this.isLoading = true
        if (!item.url || typeof item.url === 'string') return
        const params = {
          file: item.url,
          FolderTarget: 'resources/orderAttachments',
          IdTarget: item.id
        }
        const formData = new FormData()

        for (const key in params) {
          formData.append(key, params[key])
        }

        await this.$rf
          .getRequest('AuthRequest')
          .uploadFileTenant(formData)
          .then(res => {
            const url = res.data.fileUrl
            const params = {
              attachmentId: item.id,
              template: item.url_exam,
              attachmentTitle: item.title,
              productID: this.productId,
              url
            }
            item.url = url
            this.$emit('uploadFile', params)
          })

        // await Promise.all(
        //   this.attachments.map(async item => {
        //     if (!item.url || typeof item.url === 'string') return
        //     const params = {
        //       file: item.url,
        //       FolderTarget: 'resources/orderAttachments',
        //       IdTarget: item.id
        //     }
        //     const formData = new FormData()

        //     for (const key in params) {
        //       formData.append(key, params[key])
        //     }

        //     await this.$rf
        //       .getRequest('AuthRequest')
        //       .uploadFileTenant(formData)
        //       .then(res => {
        //         const url = res.data.fileUrl
        //         const params = {
        //           attachmentId: item.id,
        //           template: item.url_exam,
        //           attachmentTitle: item.title,
        //           productID: this.productId,
        //           url
        //         }

        //         // this.$rf
        //         //   .getRequest('AuthRequest')
        //         //   .putOrderFormItem(item.id, params)
        //         this.$emit('uploadFile', params)
        //       })
        //   })
        // )

        // this.$store.dispatch('ecommerce/getECommerceOrdersById', {
        //   id: Number(this.$route.params.id),
        //   params: {}
        // })

        this.$message({
          message: this.$t('lbl_upload_file_success'),
          type: 'success'
        })
        this.handleCloseModal()
      } catch (error) {
        console.log(error)
        this.$message({
          message: this.$t('lbl_upload_file_fail'),
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    handleCloseModal () {
      const id = `#modalAttachmentRequired-${this.productId}`
      window.$(id).modal('hide')
    },
    getFileName (string) {
      if (typeof string === 'string' && string.includes('https')) {
        const fileName = string.substring(string.lastIndexOf('/') + 1)
        return appUtils.truncateHash(fileName, 15)
      } else {
        return appUtils.truncateHash(string?.name, 15)
      }
    },
    handleSelectFileUpdate (e, item, index) {
      if (e?.target?.files?.length <= 0) return
      item.url = e.target.files[0]
      this.handleUpload(item)
    },
    handleUploadDocs (index, item) {
      this.$refs[`uploadFile-${index}-${item.id}`][0].click()
    },
    handleOpenFile (url) {
      window.open(url, '_blank')
    },
    getOrderStatus (status) {
      switch (status) {
        case 0:
        case ORDER_FORM_CONFIG_STATUS.PENDING:
          return {
            classes: 'bg-blue-700 text-white',
            icon: 'el-icon-loading'
          }

        case ORDER_FORM_CONFIG_STATUS.ACCEPT:
          return {
            classes: 'bg-green-500 text-white',
            icon: 'el-icon-check'
          }
        case ORDER_FORM_CONFIG_STATUS.REJECT:
          return {
            classes: 'bg-red-500 text-white',
            icon: 'el-icon-close'
          }

        default:
          return {
            classes: 'bg-white',
            icon: ''
          }
      }
    },
    getStatusLabel (status) {
      let label = ''

      switch (status) {
        case ORDER_FORM_CONFIG_STATUS.ACCEPT:
          label = this.$t('lbl_accept')
          break
        case ORDER_FORM_CONFIG_STATUS.PENDING:
          label = this.$t('lbl_pending')
          break

        case ORDER_FORM_CONFIG_STATUS.REJECT:
          label = this.$t('lbl_reject')
          break

        default:
          break
      }

      return label
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-btn {
  width: 100%;
  border: 1px dashed #20419b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 9px;
  cursor: pointer;
  gap: 4px;
}

.cs-link {
  background-color: #dee4f8;
  color: #20419b;
  border-radius: 15px;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 4px;

  cursor: pointer;
  width: fit-content;
}
</style>
